(function () {
  angular.module('app.attendance-analytics.quickview', []);

})();